import React from 'react';
import PropTypes from 'prop-types';

import PhotoSearchCheckoutSuccess from './PhotoSearchCheckoutSuccess';
import withModal from '../../../../../../../components/global/modal/withModal';

export const PHOTO_SEARCH_CHECKOUT_SUCCESS_MODAL =
  'modal/PHOTO_SEARCH_CHECKOUT_SUCCESS_MODAL';

const propTypes = {
  actionProps: PropTypes.shape({
    onDismiss: PropTypes.func,
  }),
  onRequestClose: PropTypes.func,
  content: PropTypes.node,
};

const PhotoSearchCheckoutSuccessModalContent = ({
  actionProps: { onDismiss, ...props } = {},
  onRequestClose,
  content,
}) => {
  return (
    <PhotoSearchCheckoutSuccess
      content={content}
      {...props}
      onDismiss={
        onDismiss
          ? () => {
              onDismiss();
              onRequestClose();
            }
          : undefined
      }
    />
  );
};

PhotoSearchCheckoutSuccessModalContent.propTypes = propTypes;

export default withModal(PhotoSearchCheckoutSuccessModalContent, {
  name: PHOTO_SEARCH_CHECKOUT_SUCCESS_MODAL,
  dismissible: false,
  shouldCloseOnOverlayClick: false,
  size: 'sm',
  className: 'photo-search-checkout-success-modal',
  overlayClassName: 'photo-search-checkout-success-modal-overlay',
  type: 'full',
});
